import { render, staticRenderFns } from "./FollowUpRules.vue?vue&type=template&id=0a24cc11&scoped=true&"
import script from "./FollowUpRules.vue?vue&type=script&lang=js&"
export * from "./FollowUpRules.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpRules.vue?vue&type=style&index=0&id=0a24cc11&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a24cc11",
  null
  
)

export default component.exports